import { FC, useEffect } from 'react';
import {useInstance} from 'react-ioc';
import {useQuery} from '@apollo/client';
import {observer} from 'mobx-react-lite';

import {Store} from '../../../model/store/Store';

import {me} from './__generated__/me';
import {QUERY_ME} from './me';

export const GetMe: FC = observer(() => {

    const { auth } = useInstance(Store);

    const me = useQuery<me>(QUERY_ME, {
        // pollInterval: 10000,
    });

    useEffect(() => {

        if (me.data?.me) {
            const paid = me.data?.me?.role?.name === 'Paid';
            const id = me.data.me.id;
            const documentId = me.data.me.documentId;
            const data = {
                email: me.data.me.email!,
                username: me.data?.me?.username!,
                FIO: me.data?.me?.FIO!,
                birthdate: me.data?.me?.birthdate!,
                gender: me.data?.me?.gender!,
                avatar: me.data?.me?.avatar?.url!,
            }
            auth.setData(id, documentId, data, paid)
            auth.setWidgets(me.data.me.widget)
        }
    }, [me, auth])

    useEffect(() => {
        if (auth.refresh) {
            me.refetch().then();
            auth.setRefresh(false);
        }
    }, [auth, auth.refresh, me])

    return null
})


